var map = {
	"./BigPicture.js": 88794,
	"./NewOrderDB.js": 92263,
	"./SalesArea.js": 27086,
	"./SalesCustomers.js": 72661,
	"./ShoppyCart.js": 61205,
	"./auth.js": 87701,
	"./categories.js": 41906,
	"./productView.js": 44825,
	"./products.js": 86524,
	"./tags.js": 80409
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50085;